import { EChatActionTypes } from '@r1-frontend/entities/Chat/store/constants/actions';
import { TChatState } from '@r1-frontend/entities/Chat/store/initialState';

const changeLoaded = (isLoaded: boolean): { type: EChatActionTypes.CHANGE_LOADED_CHAT, payload: Pick<TChatState, 'isLoaded'> } => ({
    type: EChatActionTypes.CHANGE_LOADED_CHAT,
    payload: {
        isLoaded,
    },
});

export default changeLoaded;
